import { Home24Regular } from '@/components/Icon'
import PATHS from '@/routes/paths'

export const PRIMARY_NAV_ITEMS = [
  { key: 'home', label: 'Home', Icon: Home24Regular, path: PATHS.HOME },
]

export const PRIMARY_NAV_GROUPS = {
  top: ['home'],
  bottom: [],
}
